module.exports = __webpack_public_path__ + "img/gb9113_14_a.prt.905a6666.jpg";